// extracted by mini-css-extract-plugin
module.exports = {"block":"block--CDezI","button":"button--yWxRA","labels":"labels--SlYHK","tag":"tag--WCyad","statesblk":"statesblk---O4mG","row":"row--t+en0","long":"long--npQt+"};
    if(module.hot) {
      // 1653630376995
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  